/* SCC Apple-grade draft, v3 "The Table". No dependencies. */
(function () {
  'use strict';
  if (window.__sccTable) return;
  window.__sccTable = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* ---------- Deal stage ---------- */
  function initDeal(root) {
    if (root.__scc) return;
    root.__scc = true;
    var stage = root.querySelector('[data-stage]');
    var tilt = root.querySelector('[data-tilt]');
    var cards = [].slice.call(root.querySelectorAll('[data-card]'));
    var panels = [].slice.call(root.querySelectorAll('[data-panel]'));
    var n = cards.length;
    if (!stage || !n) return;
    var pos = 0, stacked = root.classList.contains('is-stacked'), busy = false, dealt = false;
    var vis = Math.min(3.9, n / 2 - 0.6);

    function rel(i) { var d = i - pos; d = ((d % n) + n + n / 2) % n - n / 2; return d; }
    function activeIndex() { return ((Math.round(pos) % n) + n) % n; }

    function render() {
      var step = window.innerWidth < 750 ? 13 : 11.5;
      var ai = activeIndex();
      cards.forEach(function (c, i) {
        var s = c.style;
        if (stacked) {
          s.setProperty('--a', ((i % 3) - 1) * 1.4);
          s.setProperty('--lift', -i * 0.08);
          s.setProperty('--s', 0.94);
          s.setProperty('--o', 1);
          s.zIndex = i === ai ? n + 1 : i;
          return;
        }
        var d = rel(i), ad = Math.abs(d);
        s.setProperty('--a', (d * step).toFixed(3));
        s.setProperty('--lift', (-(1 - Math.min(ad, 1)) * 2.4).toFixed(3));
        s.setProperty('--s', (1 - Math.min(ad, 3) * 0.07).toFixed(3));
        s.setProperty('--o', clamp((vis - ad) / 0.6, 0, 1).toFixed(3));
        s.zIndex = 100 - Math.round(ad * 10);
        c.classList.toggle('is-active', i === ai);
        c.setAttribute('aria-current', i === ai ? 'true' : 'false');
        c.tabIndex = i === ai ? 0 : -1;
      });
    }

    function sync() {
      var ai = activeIndex();
      panels.forEach(function (p, i) {
        var on = i === ai;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in p) p.inert = !on;
        var now = p.querySelector('[data-now]');
        if (now) now.textContent = on && dealt ? (now.getAttribute('data-dealt') || 'You were dealt') : (now.getAttribute('data-default') || '');
      });
      var accent = cards[ai].getAttribute('data-accent');
      if (accent) root.style.setProperty('--scc-accent', accent);
    }

    function go(delta) {
      if (busy || stacked) return;
      dealt = false;
      pos = Math.round(pos) + delta;
      render(); sync();
    }

    function fanOut(target, stagger) {
      pos = target;
      stacked = false;
      if (stagger) {
        cards.forEach(function (c, i) {
          var d = Math.abs(rel(i));
          c.style.transitionDelay = Math.round(d * 70) + 'ms';
          var f = c.firstElementChild;
          if (f) f.style.transitionDelay = Math.round(d * 70 + 60) + 'ms';
        });
      }
      root.classList.remove('is-stacked', 'is-riffling');
      render(); sync();
      setTimeout(function () {
        cards.forEach(function (c) {
          c.style.transitionDelay = '';
          if (c.firstElementChild) c.firstElementChild.style.transitionDelay = '';
        });
        busy = false;
      }, 1300);
    }

    function deal(target) {
      if (busy) return;
      if (reduce) { dealt = true; pos = target; render(); sync(); return; }
      busy = true;
      stacked = true;
      root.classList.add('is-stacked');
      render();
      setTimeout(function () { root.classList.add('is-riffling'); }, 480);
      setTimeout(function () { root.classList.remove('is-riffling'); }, 800);
      setTimeout(function () { root.classList.add('is-riffling'); }, 1080);
      setTimeout(function () { root.classList.remove('is-riffling'); }, 1380);
      setTimeout(function () { dealt = true; fanOut(target, true); }, 1750);
    }

    function randomOther() {
      if (n < 2) return 0;
      var ai = activeIndex(), r = ai;
      while (r === ai) r = Math.floor(Math.random() * n);
      return r;
    }

    /* Start: a shared link (?deal=handle) opens on that deck. */
    var start = 0;
    try {
      var want = new URLSearchParams(window.location.search).get('deal');
      if (want) cards.forEach(function (c, i) { if (c.getAttribute('data-handle') === want) { start = i; dealt = true; } });
    } catch (e) {}
    pos = start;
    if (reduce || !stacked) { stacked = false; root.classList.remove('is-stacked'); render(); sync(); }
    else { busy = true; render(); sync(); setTimeout(function () { fanOut(start, true); }, 350); }

    /* Drag to riffle through the fan. */
    var drag = null, moved = false;
    function cw() { return cards[0].getBoundingClientRect().width || 220; }
    stage.addEventListener('pointerdown', function (e) {
      if (busy || stacked || (e.button && e.button !== 0)) return;
      drag = { x: e.clientX, y: e.clientY, pos: pos, w: cw() };
      moved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!moved && Math.abs(dx) < 8) return;
      if (!moved) { moved = true; root.classList.add('is-dragging'); dealt = false; }
      pos = drag.pos - dx / (drag.w * 0.62);
      render();
    }, { passive: true });
    function endDrag() {
      if (!drag) return;
      drag = null;
      root.classList.remove('is-dragging');
      if (moved) { pos = Math.round(pos); render(); sync(); setTimeout(function () { moved = false; }, 0); }
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    cards.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        if (moved || busy || stacked) { e.preventDefault(); return; }
        var d = Math.round(rel(i));
        if (d !== 0) { go(d); return; }
        var url = c.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { go(-1); e.preventDefault(); }
      else return;
      var a = cards[activeIndex()]; if (a) a.focus({ preventScroll: true });
    });
    [].forEach.call(root.querySelectorAll('[data-step]'), function (b) {
      b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-step'), 10) || 1); });
    });
    var dealBtn = root.querySelector('[data-deal]');
    if (dealBtn) dealBtn.addEventListener('click', function () { deal(randomOther()); });

    /* Roulette: the fan spins like a wheel, slows down and lands on a random deck. */
    var spinBtn = root.querySelector('[data-spin]');
    function spin() {
      if (busy || n < 2) return;
      var target = randomOther();
      if (reduce) { dealt = true; pos = target; render(); sync(); return; }
      if (stacked) { stacked = false; root.classList.remove('is-stacked'); }
      busy = true; dealt = false; root.classList.add('is-spinning'); if (spinBtn) spinBtn.disabled = true;
      var from = pos, base = Math.round(pos), d = ((target - base) % n + n) % n, to = base + n * 2 + d;
      var dur = 3200 + Math.random() * 600, t0 = null, lastI = Math.round(from);
      function ease(t) { return 1 - Math.pow(1 - t, 4); }
      function frame(ts) {
        if (t0 == null) t0 = ts;
        var t = Math.min(1, (ts - t0) / dur);
        pos = from + (to - from) * ease(t);
        render();
        var ci = Math.round(pos); if (ci !== lastI) { lastI = ci; try { if (navigator.vibrate) navigator.vibrate(4); } catch (e) {} sync(); }
        if (t < 1) { requestAnimationFrame(frame); return; }
        pos = to; render(); dealt = true; sync();
        root.classList.remove('is-spinning'); root.classList.add('is-landed');
        setTimeout(function () { root.classList.remove('is-landed'); }, 1200);
        busy = false; if (spinBtn) spinBtn.disabled = false;
        try { if (navigator.vibrate) navigator.vibrate([20, 40, 30]); } catch (e) {}
      }
      requestAnimationFrame(frame);
    }
    if (spinBtn) spinBtn.addEventListener('click', spin);

    /* Share the deck on the table. */
    var share = root.querySelector('[data-share]');
    if (share) share.addEventListener('click', function () {
      var c = cards[activeIndex()];
      var url = window.location.origin + window.location.pathname + '?deal=' + encodeURIComponent(c.getAttribute('data-handle'));
      var text = (share.getAttribute('data-text') || '').replace('[deck]', c.getAttribute('data-name') || '');
      var label = share.textContent;
      function done(msg) { share.textContent = msg; setTimeout(function () { share.textContent = label; }, 2200); }
      if (navigator.share) { navigator.share({ title: document.title, text: text, url: url }).catch(function () {}); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text + ' ' + url).then(function () { done(share.getAttribute('data-copied') || 'Link copied'); }, function () { window.prompt('', url); });
      } else { window.prompt('', url); }
    });

    /* Mouse tilt and glare (desktop only). */
    if (!reduce && tilt && window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        var r = stage.getBoundingClientRect();
        var x = clamp((e.clientX - r.left) / r.width, 0, 1) - 0.5;
        var y = clamp((e.clientY - r.top) / r.height, 0, 1) - 0.5;
        tilt.style.setProperty('--tx', (x * 9).toFixed(2));
        tilt.style.setProperty('--ty', (-y * 6).toFixed(2));
        root.style.setProperty('--gx', (x * 70).toFixed(1));
      }, { passive: true });
      root.addEventListener('pointerleave', function () {
        tilt.style.setProperty('--tx', 0); tilt.style.setProperty('--ty', 0);
      });
    }
    window.addEventListener('resize', function () { if (!stacked) render(); });
  }

  /* ---------- Pinned chapters ---------- */
  var chapters = [], ticking = false;
  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  function updateChapters() {
    ticking = false;
    var vh = window.innerHeight;
    chapters.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      var p = clamp((vh * 0.35 - r.top) / ((r.height - vh) * 0.75 + vh * 0.35), 0, 1);
      el.style.setProperty('--p', ease(p).toFixed(4));
      el.style.setProperty('--q', clamp((p - 0.3) / 0.35, 0, 1).toFixed(4));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(updateChapters); } }
  function initChapters() {
    chapters = [].slice.call(document.querySelectorAll('[data-scc-ch]'));
    if (!chapters.length) return;
    if (reduce) { chapters.forEach(function (el) { el.style.setProperty('--p', 1); el.style.setProperty('--q', 1); }); return; }
    if (!initChapters.bound) {
      initChapters.bound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    updateChapters();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-scc-deal]'), initDeal);
    initChapters();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
